import { CampaignGoalType } from '../ad-builder/CampaignGoalType';

export interface Industry {
  id: number;
  name: string;
  averageVolume: number;
  averageCostPer: number;
}

interface IndustryComparison {
  averageVolume: number;
  averageCostPer: number;
}

export interface BusinessIndustryComparison extends IndustryComparison {
  kpiName: string;
  industry?: Industry;
  optimizationAverages: IndustryOptimizationComparison[];
}

export interface IndustryOptimizationComparison extends IndustryComparison {
  goal: CampaignGoalType;
}

export const exampleIndustry: Industry = {
  id: 1,
  name: 'Industry',
  averageCostPer: 0.23,
  averageVolume: 10,
};

export const exampleBusinessIndustryComparison: BusinessIndustryComparison = {
  kpiName: 'Leads',
  averageCostPer: 0.23,
  averageVolume: 10,
  industry: exampleIndustry,
  optimizationAverages: [
    {
      goal: CampaignGoalType.LeadGeneration,
      averageCostPer: 10,
      averageVolume: 100,
    },
  ],
};
